import React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";

export interface DividerInterface {
    divide: InjectableCss;
}

export const dividerStyle: DividerInterface = {
    divide: {
        css: css`
            width: 100%;
            border-top: 1px solid ${WhitecapColors.lightBlack};
            margin-bottom: 10px;
        `,
    },
};
const styles = dividerStyle;
const Divider = ({ borderTop = `1px solid ${WhitecapColors.lightBlack}` }) => {
    return <StyledWrapper {...styles.divide} style={{ borderTop: borderTop }}></StyledWrapper>;
};

export default Divider;
